import script from "./limit-risk.vue?vue&type=script&setup=true&lang=js"
export * from "./limit-risk.vue?vue&type=script&setup=true&lang=js"

import "./limit-risk.vue?vue&type=style&index=0&id=dce5f248&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dce5f248"]])

export default __exports__